export function imagePriority(priority: boolean | undefined, index: number) {
  if (priority !== undefined) {
    return priority;
  }

  return index < 2;
}
